// extracted by mini-css-extract-plugin
module.exports = {"page":"OrderQuestionsPage_page__2oNgH","tabs":"OrderQuestionsPage_tabs__2ftOC"};